module.exports = __webpack_public_path__ + "static/media/51--maui-drink.baf4263f.jpeg";